Ext.define('SA.BeyondLimitDefaultMessage', {
    alias: 'widget.beyond-limit-default-message',
    extend: 'Ext.Component',

    cls: 'sa-beyond-limit-default-message',

    tpl: [
        '<svg class="sa-beyond-limit-default-message-svg">',
            '<use href="#sa-icon-warning"></use>',
        '</svg>',
        '<div>',
            '<div class="sa-beyond-limit-default-message-primary-text">',
                '<tpl if="beyondPerWeekLimit && !beyondPerYearLimit">',
                    'This export would exceed the maximum weekly data export limit for one or more datasets.',
                '<tpl elseif="beyondPerYearLimit && !beyondPerWeekLimit">',
                    'This export would exceed the maximum annual data export limit for one or more datasets.',
                '<tpl else>',
                    'This export would exceed the maximum weekly and annual data export limits for one or more datasets.',
                '</tpl>',
            '</div>',
            'For information about which datasets triggered this error, please <a href="#">click here</a>.',
        '</div>'
    ],

    initEvents() {
        this.callParent();

        this.el.on('click', this.onClickLink, this, {delegate: 'a', preventDefault: true});
    },

    onClickLink() {
        this.fireEvent('click:link');
    }
});